import React from 'react';
import { SxPropsTheme } from '../../styles/theme';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import { GradientIcon } from '../gradients/GradientIcon';
import { useTheme } from '@mui/material/styles';
import { useMobile } from 'src/hooks/useMobile';
import { useDateFormatter } from 'src/hooks/useDateFormatter';
import { GradientBorder } from '../gradients/GradientBorder';
import { SHORT } from 'src/util/dates/presets/dates';

const BORDER_PROPS = { borderRadius: '10px', sx: { maxWidth: '286px' } };

export type GameDetailsListProps = {
  releaseDate?: Date;
  gameSize?: string;
  controllerSupport?: boolean;
};

export function GameDetailsList({
  releaseDate,
  gameSize,
  controllerSupport,
}: GameDetailsListProps) {
  const theme = useTheme();
  const isMobile = useMobile();
  const format = useDateFormatter({
    dateFormat: SHORT,
    timeFormat: undefined,
    separator: '',
  });

  const dateFormatted = releaseDate ? format(releaseDate) : 'TBD';
  const listItemBoxStyle: SxPropsTheme = {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.elevation['10'],
    borderRadius: '10px',
    alignItems: 'center',
    width: '100%',
    px: '16px',
    py: '10px',
    maxHeight: '48px',
  };
  return (
    <List
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'row' : 'column',
        flexWrap: 'wrap',
        justifyContent: isMobile ? 'center' : undefined,
        gap: '16px',
        width: '100%',
        py: 0,
      }}
    >
      {!!releaseDate && (
        <GradientBorder disableGlow={true} {...BORDER_PROPS}>
          <Box sx={listItemBoxStyle}>
            <Typography variant="subtitle1">RELEASE DATE</Typography>
            <Typography
              variant="body1"
              sx={{ textTransform: 'uppercase', pl: 2 }}
            >
              {dateFormatted}
            </Typography>
          </Box>
        </GradientBorder>
      )}
      {!!gameSize && (
        <GradientBorder disableGlow={true} {...BORDER_PROPS}>
          <Box sx={listItemBoxStyle}>
            <Typography variant="subtitle1">SIZE</Typography>
            <Typography variant="body1" sx={{ pl: 2 }}>
              {gameSize}
            </Typography>
          </Box>
        </GradientBorder>
      )}
      {controllerSupport && (
        <GradientBorder disableGlow={true} {...BORDER_PROPS}>
          <Box sx={{ ...listItemBoxStyle, justifyContent: 'flex-start' }}>
            <GradientIcon IconComponent={SportsEsportsIcon} />
            <Typography sx={{ paddingLeft: '8px' }} variant="body1">
              Controller Support
            </Typography>
          </Box>
        </GradientBorder>
      )}
    </List>
  );
}
